import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import SoftButton from 'components/SoftButton';
import { useTranslation } from 'react-i18next';
import styles from '../agency-manager.module.scss';
import { UserDataContext } from 'shared/context/userDataContext';

const AgencyDetailsActions = ({
  isEditMode,
  handleEditClick,
  handleSave,
  handleCancel,
  handleClose,
  handleNotesClick,
}) => {
  const { t } = useTranslation();
  const { userRoles } = useContext(UserDataContext);

  return (
    <Box className={styles.actionsContainer}>
      {userRoles.t3Modify && (
        <Box className={styles.actionsLeft}>
          {!isEditMode ? (
            <>
              <SoftButton
                variant="contained"
                color="white"
                className={styles.actionsButton}
                onClick={handleEditClick}
              >
                {t('COMMON.edit')}
              </SoftButton>
              <SoftButton
                variant="contained"
                color="info"
                className={styles.actionsButton}
                onClick={handleNotesClick}
              >
                {t('COMMON.notes')}
              </SoftButton>
            </>
          ) : (
            <>
              <SoftButton
                variant="contained"
                color="info"
                className={styles.actionsButton}
                onClick={handleSave}
              >
                {t('COMMON.save')}
              </SoftButton>
              <SoftButton
                variant="contained"
                color="secondary"
                className={styles.actionsButton}
                onClick={handleCancel}
              >
                {t('COMMON.cancel')}
              </SoftButton>
            </>
          )}
        </Box>
      )}
      <Box className={styles.footerRight}>
        <SoftButton
          variant="contained"
          color="info"
          className={styles.actionsButton}
          onClick={handleClose}
        >
          {t('COMMON.close')}
        </SoftButton>
      </Box>
    </Box>
  );
};

AgencyDetailsActions.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleNotesClick: PropTypes.func.isRequired,
};

export default AgencyDetailsActions;
